import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

const CategoryRowPopover = ({ open, onClose, trigger, children }) => {
  const anchorRef = useRef(null);
  const popoverRef = useRef(null);
  const [openUpward, setOpenUpward] = useState(false);

  useLayoutEffect(() => {
    if (!open || !anchorRef.current || !popoverRef.current) return;
    const anchorRect = anchorRef.current.getBoundingClientRect();
    const popoverHeight = popoverRef.current.offsetHeight || 240;
    const spaceBelow = window.innerHeight - anchorRect.bottom;
    setOpenUpward(spaceBelow < popoverHeight + 12 && anchorRect.top > spaceBelow);
  }, [open, children]);

  useEffect(() => {
    if (!open) return undefined;
    const handlePointerDown = (e) => {
      if (anchorRef.current?.contains(e.target) || popoverRef.current?.contains(e.target)) return;
      onClose();
    };
    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [open, onClose]);

  return (
    <div className="position-relative d-inline-block">
      <span ref={anchorRef}>{trigger}</span>
      {open ? (
        <div
          ref={popoverRef}
          className="border rounded bg-white shadow p-2 position-absolute"
          style={{
            zIndex: 20,
            right: 0,
            minWidth: '340px',
            maxWidth: '400px',
            ...(openUpward
              ? { bottom: '100%', marginBottom: '4px' }
              : { top: '100%', marginTop: '4px' })
          }}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default CategoryRowPopover;
